import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, MessageBoxVariant, useTranslations } from "@jti/ui";
import WarningIcon from "@jti/ui/icons/information.svg";
export const SticksProductUnavailable = () => {
    const { __ } = useTranslations();
    return (_jsx(MessageBox, { isVisible: true, variant: MessageBoxVariant.error, icon: WarningIcon, title: __("productdetails.sticks.error.title"), children: _jsx("p", { children: __("productdetails.sticks.error.description") }) }));
};
//# sourceMappingURL=SticksProductUnavailable.js.map